import React from 'react';
import Card from '@/components/UI/Card';
import Button from '@/components/UI/Button';
import { DeleteButton, EditButton, EmptyState } from '@/components/UI';
import type { PositionSizeRule } from '@einhaus/project314-types';

interface PositionSizeRulesCardProps {
    rules: PositionSizeRule[];
    onDeleteRule: (ruleId: string, type: 'directionMax' | 'categoryLimit' | 'positionSizeRule') => void;
    setEditingRuleId: React.Dispatch<React.SetStateAction<string | null>>;
    setNewRule: React.Dispatch<React.SetStateAction<Partial<PositionSizeRule>>>;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const PositionSizeRulesCard: React.FC<PositionSizeRulesCardProps> = ({
    rules,
    onDeleteRule,
    setEditingRuleId,
    setNewRule,
    setShowModal
}) => (
    <Card className="mb-4" headerClassName="flex justify-between items-center" title="Position Size Rules">
        <Button
            variant="link"
            onClick={() => {
                setEditingRuleId(null);

                setNewRule({
                    type: 'fixed',
                    entityTypes: ['Asset'],
                    value: 0
                });

                setShowModal(true);
            }}
        >
            + Add
        </Button>

        {rules.length === 0 ? (
            <EmptyState size="sm" title="No position size rules configured." />
        ) : (
            <div className="overflow-x-auto">
                <table className="min-w-full bg-zinc-800 text-white border-collapse">
                    <thead>
                        <tr className="bg-zinc-700">
                            <th className="px-4 py-2 text-left">Type</th>
                            <th className="px-4 py-2 text-left">Entity Types</th>
                            <th className="px-4 py-2 text-left">Value</th>
                            <th className="px-4 py-2 text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rules.map((rule, index) => (
                            <tr className={index % 2 === 0 ? 'bg-zinc-800' : 'bg-zinc-750'} key={rule.id}>
                                <td className="px-4 py-2 border-t border-zinc-700">{rule.type}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">{rule.entityTypes.join(', ')}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">{rule.value}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">
                                    <div className="flex items-center gap-2">
                                        <EditButton
                                            size="sm"
                                            onClick={() => {
                                                setEditingRuleId(rule.id);

                                                setNewRule({
                                                    type: rule.type,
                                                    entityTypes: rule.entityTypes,
                                                    value: rule.value
                                                });

                                                setShowModal(true);
                                            }}
                                        />
                                        <DeleteButton size="sm" onClick={() => onDeleteRule(rule.id, 'positionSizeRule')} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </Card>
);

export default PositionSizeRulesCard;
